import { Icon } from '@iconify/react/dist/iconify.js'
import axios from 'axios'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import { API_URL } from '..'
import $ from 'jquery';

const ForgotPasswordLayer = () => {
    const [email, setEmail] = useState('')
    const handleSubmit = async ()=>{
        try {
            if(email === ""){
                Swal.fire({
                    title: 'Email is required',
                    icon:'error',
                    text: 'Email is required field. Please try your registered email.'
                });
                return false;
            }else{
                const response = await axios.post(API_URL+'/api/user/forgot-password' , {email: email} , {headers: {'Content-Type':'application/json'}});
                if(response.status === 200) {
                    // $('#exampleModal').modal('show')
                    Swal.fire({
                        title:'Email is sent',
                        icon:'success',
                        text:'Thank you, check your email for instructions to reset your password'
                    })
                    setEmail('');
                }else{
                    Swal.fire({
                        title:'Email is not send',
                        icon:'error',
                        text:'Error while sending email that you are provided'
                    })
                }

            }
            
        } catch (error) {
            Swal.fire({
                title:'Email is not send',
                icon:'error',
                text:error.message
            })
            
        }
    }
    return (
        <>
            <section className="auth forgot-password-page bg-base d-flex flex-wrap">
                <div className="auth-left d-lg-block d-none">
                    <div className="d-flex align-items-center flex-column h-100 justify-content-center">
                    <img src="assets/images/signin.webp" alt="Sign In Illustration" />
                    </div>
                </div>
                <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
                    <div className="max-w-464-px mx-auto w-100">
                        <div>
                            <h4 className="mb-12">Forgot Password</h4>
                            <p className="mb-32 text-secondary-light text-lg">
                                Enter the email address associated with your account and we will
                                send you a new password.
                            </p>
                        </div>
                        <form action="#">
                            <div className="icon-field">
                                <span className="icon top-50 translate-middle-y">
                                    <Icon icon="mage:email" />
                                </span>
                                <input
                                    type="email"
                                    onChange={(e)=>setEmail(e.target.value)}
                                    className="form-control h-56-px bg-neutral-50 radius-12"
                                    placeholder="Enter Email"
                                />
                            </div>
                            <button
                                type="button"
                                className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                                onClick={handleSubmit}
                            >
                                Continue
                            </button>
                            <div className="text-center">
                                <Link to="/sign-in" className="text-primary-600 fw-bold mt-24">
                                    Back to Sign In
                                </Link>
                            </div>
                            
                        </form>
                    </div>
                </div>
            </section>
            {/* Modal */}
        
        </>

    )
}

export default ForgotPasswordLayer